<!-- компонент workBoard: рабочая доска приложения для аутентифицированных пользователей -->
<template>
<div v-if="$store.state.is_auth === true">
	<nav class="navbar navbar-default navbar-fixed-top" style="right: -15px;">
		<div class="container-fluid" style="padding-right: 30px;">
			<div class="navbar-header pull-left">
				<button type="button" class="navbar-toggle collapsed" @click.stop="toggleSideMenu" :class="{ 'taped': sideMenuVisible }">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link to="/" class="navbar-brand w5-navbar-logo-link hidden-xs">				
					<img :src="stylePathToLogo || '/static/img/logo/logo.png'" class="w5-navbar-logo-img visible-xs">
					<img :src="stylePathToLogoText || '/static/img/logo/logo-text.png'" class="w5-navbar-logo-img hidden-xs">
				</router-link>
			</div>
			<div class="navbar-header pull-right">
				<!--
				<span v-if="this.$store.state.user_type === 'client'" class="navbar-brand w5-navbar-link linkified balance-rest visible-xs" @click.stop="showBalanceData = true">
					<font-awesome-icon :icon="AppName == 'vdsina.com' ? 'dollar-sign' : 'ruble-sign'" />
				</span>
				 -->
				<Lang />
				<router-link v-if="$store.state.user_account" to="/dashboard/info" class="navbar-brand w5-navbar-link linkified">
					<span class="w5-account-info">{{ this.$store.state.user_account }} </span>
				</router-link>
				<router-link to="/options" class="navbar-brand w5-navbar-link linkified">
					<img class="user-mini-avatar" :src="APIServerUrl + this.$store.state.user_avatar" />
					<span class="hidden-xs"> {{ this.$store.state.user_login }}</span>
				</router-link>
				<router-link to="/logout" class="navbar-brand w5-navbar-link last-right">
					<font-awesome-icon icon="lock" v-show="!form_Loading" />
					<img class="pull-left" src="/static/img/loading16.gif" v-show="form_Loading" />
					<span class="hidden-xs"> {{ localeFtc('main/logout') }}</span>
				</router-link>
			</div>
		</div>
	</nav>

	<!-- баланс для мобилы -->
	<div v-if="this.$store.state.user_type === 'client'" v-show="showBalanceData" class="mobile-client-balance" @click.stop>
		<div>
			<!-- закрывашка -->
			<button type="button" class="close" @click.stop="showBalanceData = false">&times;</button>
			<!-- реальный остаток -->
			<span>{{ 'operation/real_balance_short' | ftc }}:</span>
			<span v-if="$store.state.user_balance.real !== ''" class="font-weight-500"><a href="#" @click.stop="GoToOperation('real')" :class="{ 'color-red': this.$store.state.user_balance.real < 0 }"><Money :value="this.$store.state.user_balance.real | money2" /></a>&nbsp;<span class="font-weight-500" v-html="localeFtc('main/ruble')"> </span></span>
			<br>
			<!-- бонусы -->
			<span>{{ 'operation/purse_bonus' | ftc }}:</span>
			<span v-if="$store.state.user_balance.bonus !== ''" class="font-weight-500"><a href="#" @click.stop="GoToOperation('bonus')" :class="{ 'color-red': this.$store.state.user_balance.bonus < 0 }"><Money :value="this.$store.state.user_balance.bonus | money2" /></a>&nbsp;<span class="font-weight-500" v-html="localeFtc('main/ruble')"> </span></span>
		</div>
	</div>
	
	<div class="container-fluid">
		<div class="row main-wrapper">

			 <transition name="fade">
			 	<!-- Левое меню -->
				<div class="col-sm-2 sidebar" v-show="sideMenuVisible">
					<!-- кнопка создания VDS для клиентов -->
					<span v-if="this.$store.state.user_type === 'client' && isAccess('service/create')"						
						class="w5-create-vds-button btn btn-submit full-width font-weight-400 margin-bottom-15 padding-0"
						@click="createVdsByClient">
						<font-awesome-icon icon="plus" />
						<span class="hidden-sm">{{ 'main/create' | ftc }} </span><span>{{ 'server/server' | ftc }}</span>
					</span>
					<!-- само меню -->
					<ul class="nav nav-sidebar">
						<li v-for="(item, what) in Config.leftMenu" @click="clickOnSideMenu" v-if="isAccess(item.link)" :key="what">
							<router-link :to="item.link" :ref="what === 'ticket' ? 'ticket' : item.link.replace(/\//g, '_')">
							 	{{ item.title | ftc }}
							 	<!-- если тикетинца и есть соответствующий счетчик -->
							 	<span v-if="what === 'ticket' && $store.state.ticketData && $store.state.ticketData.counters && $store.state.ticketData.counters.all && $store.state.ticketData.counters.all > 0"
							 		class="badge ticket-message-counter-badge margin-left-6">
							 			{{ $store.state.ticketData.counters.all }}
							 	</span>
							 	<!-- если заявки и есть соответствующий счетчик -->
							 	<span v-if="what === 'request' && $store.state.requestCounter && $store.state.requestCounter.all && $store.state.requestCounter.all > 0"
							 		class="badge ticket-message-counter-badge margin-left-6">
							 			{{ $store.state.requestCounter.all }}
							 	</span>
							</router-link>
						</li>
					</ul>
					<!-- блок баланса для клиентов -->
					<div v-if="this.$store.state.user_type === 'client'" class="w5-client-balance">
						
						<div v-if="$store.state.user_balance.real !== ''" class="info-box-balance">
							<span class="info-box-balance-icon bg-aqua" @click="GoToOperation('real')"><font-awesome-icon :icon="AppName == 'vdsina.com' ? 'dollar-sign' : 'ruble-sign'" class="color-white" /></span>
							<div class="info-box-balance-content real-balance">
								<span class="info-box-balance-text">{{ 'operation/real_balance_short' | ftc }}:</span>								
								<span class="info-box-balance-value for-balance" :class="{ 'color-red': $store.state.user_balance.real < 0 }" @click="GoToOperation('real')"><Money :value="$store.state.user_balance.real | money2" /></span> <span v-html="localeFtc('main/ruble')" class="for-balance-currency"></span>
							</div>
						</div>

						<div v-if="$store.state.user_balance.bonus !== ''" class="info-box-balance">
							<span class="info-box-balance-icon bg-aqua" @click="GoToOperation('bonus')"><font-awesome-icon icon="piggy-bank" class="color-white" /></span>
							<div class="info-box-balance-content bonus-balance">
								<span class="info-box-balance-text">{{ 'operation/purse_bonus' | ftc }}:</span>								
								<span class="info-box-balance-value for-balance" :class="{ 'color-red': $store.state.user_balance.bonus < 0 }" @click="GoToOperation('bonus')"><Money :value="$store.state.user_balance.bonus | money2" /></span> <span v-html="localeFtc('main/ruble')" class="for-balance-currency"></span>
							</div>
						</div>

						<div v-if="$store.state.user_forecast" class="info-box-balance">
							<span class="info-box-balance-icon bg-gray"><font-awesome-icon icon="exclamation-circle" class="color-white" /></span>
							<div class="info-box-balance-content">
								<span class="info-box-balance-text">{{ 'operation/forecast' | ftc }}:</span>
								<span class="info-box-balance-value">{{ $store.state.user_forecast | date('d.m.Y') }}</span>&nbsp;<notice :text="'main/forecast_notice' | ftc" :small="true" />
							</div>
						</div>
					</div>

				</div>
				<!-- ====== -->
			</transition>
    
			<!-- Основной блок приложения -->
			<div class="col-sm-10" :class="$store.state.user_type === 'admin' ? 'main-for-admin' : 'main-for-client'">

				<!-- ===== кнопка верхних вкладок для мобильников ===== -->
				<div class="mobile-tabs-button margin-10-0 visible-xs">
					<span @click.stop="openMibileTabsMenu" class="cursor-pointer">
						<font-awesome-icon v-if="Object.keys(tabs).length > 1" icon="chevron-down" />
						<span class="h4">{{ mobileShowUpperTab | ftc }}</span>
					</span>

					<transition name="fadeControl">
						<ul
							v-if="Object.keys(tabs).length > 1"
							v-show="mobileTabsMenuShow"
							v-click-outside="hideMibileTabsMenu"
							class="mobile-tabs-menu">
							<li v-for="(tab, idx) in tabs" v-if="isAccess(makeTabUrl(idx, tab))" @click.stop="hideMibileTabsMenu" :key="idx">
								<router-link :to="makeTabUrl(idx, tab)">
									{{ tab | ftc }}<span v-if="counterTicketTab(idx)" class="badge ticket-message-counter-badge margin-left-6">{{ counterTicketTab(idx) }}</span>
								</router-link>
							</li>
						</ul>
					</transition>
				</div>
				<!-- ================================= -->

				<!-- Верхние вкладки для десктопа -->
				<ul v-if="tabs" class="nav nav-tabs hidden-xs">
					<li v-for="(tab, idx) in tabs" :class="{ active: ActiveTab === idx }" v-if="isAccess(makeTabUrl(idx, tab))" :key="idx">
						<router-link :to="makeTabUrl(idx, tab)">
							{{ tab | ftc }}<span v-if="counterTicketTab(idx)" class="badge ticket-message-counter-badge margin-left-6">{{ counterTicketTab(idx) }}</span>
						</router-link>
					</li>
				</ul>
				<!-- ============================== -->

				<!-- блок просмотра ROUTER-VIEW -->
				<router-view></router-view>				
				<!-- ============================== -->
			</div>
			<!-- ==================================== -->

		</div>
	</div>

	<!-- диалог подтверждения -->
	<div v-show="showConfirmModalDialog" @click="hideConfirmModalDialog" class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container" @click.stop>

				<!-- заголовок -->
				<div class="modal-header">
					<span class="font-weight-500">{{ confirmModalDialogTitle ? confirmModalDialogTitle : '' | ftc }}</span>
					<button type="button" class="close" @click="hideConfirmModalDialog">&times;</button>
				</div>

				<!-- тело диалога -->
				<div class="modal-body"><p class="padding-0-5" v-withSafeTags="confirmModalDialogText"></p></div>

				<!-- подвал -->
				<div class="modal-footer">
					<span class="btn btn-submit pull-right" @click="confirmModalDialogCallback">{{ 'main/confirm' | ftc }}</span>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import { EventBus } from '@/bus.js'
import notice from '@/components/elements/notice'
import Money from '@/components/elements/money'
import Lang from '@/components/elements/lang'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'workBoard',

	//=========================================================================
	// локальные переменные компонента
	//=========================================================================
	data: function() {
		return {
			// наименование CRUD-объекта (например: 'bonus')
			crud: null,
			// показывает/скрывает меню верхних вкладок для мобильников
			mobileTabsMenuShow: false,
			// верхние вкладки
			tabs: {},
			showBalanceData: false,

			// даилог подтверждения действия
			showConfirmModalDialog: false,
			confirmModalDialogTitle: '',
			confirmModalDialogText: '',
			confirmModalDialogCallback: () => {}
		}
	},
	//=========================================================================
	// высичляемый переменные
	//=========================================================================
	computed: {
		//---------------------------------------------------------------------
		// текущая конфигурация
		//---------------------------------------------------------------------
		Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig
			else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig
			else return {}
		},
		//---------------------------------------------------------------------
		// активная верхняя вкладка
		//---------------------------------------------------------------------
		ActiveTab() {
			if (this.crud === 'ticket' && this.$store.state.ticketData.currentDepartmentId)
			{
				return 'ticket/department/' + this.$store.state.ticketData.currentDepartmentId
			}

			if (this.crud === 'user' && this.$route.path.indexOf('/user/alerts') === 0 && this.$store.state.user_type !== 'admin')
			{
				return 'alerts'
			}

			if (this.crud === 'ipptrpool')
			{
				if (this.$store.state.user_type === 'admin')
				{
					if (this.$store.state.menuSelectingPreset === 'admin_view_ipptrpool')
						return 'ipptrpool'
					else
						return 'ippool'
				}
			}

			if (this.crud === 'iphistory')
			{
				return 'ippool'
			}

			return this.crud
		},
		//---------------------------------------------------------------------
		// показываем текущую верхную вкладку для мобил
		//---------------------------------------------------------------------
		mobileShowUpperTab() {
			// сначала идут частные случаи
			if (this.crud === 'ticket')
			{
				if (this.ActiveTab && this.ActiveTab in this.tabs && this.tabs[this.ActiveTab])
					return this.tabs[this.ActiveTab]
			}

			// по умолчанию
			return this.tabs[this.crud]
		}
	},
	//=========================================================================
	// локальные методы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// событие - клик по пункту левого меню
		//---------------------------------------------------------------------
		clickOnSideMenu(e) {
			this.getWindowWidth(e)
		},
		//---------------------------------------------------------------------
		// включение/выключение левого меню
		//---------------------------------------------------------------------
		toggleSideMenu() {
			this.sideMenuVisible = !this.sideMenuVisible
		},
		//---------------------------------------------------------------------
		// запрос на подтверждение на выход из приложения
		//---------------------------------------------------------------------
		exitFromApp() {
			// заголовок диалога
			this.confirmModalDialogTitle = 'main/logout'

			// вопрос диалога
			this.confirmModalDialogText = this.localeFtc('main/logout_request')

			// определяем колбак для подтверждающей кнопки диалога
			this.confirmModalDialogCallback = () => this.exitFromAppProcess()

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showConfirmModalDialog = true
		},
		//---------------------------------------------------------------------
		// выход из приложения
		//---------------------------------------------------------------------
		exitFromAppProcess() {
			// сначала нужно почистить все статусы
			// 1. статусы по тикетам
			if (this.crud === 'ticket' && this.$store.state.ticketData.ticketViewId)
			{
				// шлем статусы "done-post" и "done-view"
				// чистим аутентификацию и идем в форму логина
				Promise.all([
					this.setTicketStatus('done-post'),
					this.setTicketStatus('done-view')
				])
				.then(
					() => this.clearAndGotoLogin(),
					() => this.clearAndGotoLogin()
				)
			}
			else this.clearAndGotoLogin()
		},
		//---------------------------------------------------------------------
		// устанавливает статус
		//---------------------------------------------------------------------
		setTicketStatus(status) {
			// если тикет уже не просматривают
			if (!this.$store.state.ticketData.ticketViewId) return
			// формируем URL
			let _url = this.APIServerUrl + '/ticket/view/' + this.$store.state.ticketData.ticketViewId + '?additional=setState&state=' + status

			return new Promise(
				(resolve, reject) => {
					this.$http.get(_url).then(
						// success
						resGet => {
							// получаем ответ
							let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
							// если сразу статус "ok"
							if (_dt && _dt['status'] === 'ok') resolve('yes')
							// если пришел csrf-код
							else if (_dt && _dt['_csrf']) resolve('csrf')
							// ничего этого нет - ошибка
							else reject(resGet)
						},
						// fail
						resGet => reject(resGet)
					)
				}
			)
		},
		//---------------------------------------------------------------------
		// функция обнуляет аутентификацию и редиректит на форму логина
		//---------------------------------------------------------------------
		clearAndGotoLogin() {
			// обнуляем ID просматирваемого тикета
			this.$store.commit('setTicketViewId', false)

			// закроем все нотификации
			EventBus.$emit('w5-notificator-remove-all')

			// обнуляем флаг что форма изменена
			this.$store.commit('changedForm', false)

			// запрос на выход из системы
			this.forms_GetThenPost('/logout', false,
				// успех
				(data) => {
					this.$store.commit('dropAuth')
					this.$router.push('/login')
				},
				// провал
				(data) => {
					this.$router.push('/')
				}
			)
		},
		//---------------------------------------------------------------------
		// определяет - активна вкладка или нет (функция устарела, но пока не убираем)
		//---------------------------------------------------------------------
		isTabActive(idx) {
			// сначала идут частные случаи
			if (this.crud === 'ticket')
			{
				// это вкладка "Все"
				if (idx === 'ticket')
				{
					// есть выбранный отдел?
					if (this.$store.state.ticketData.currentDepartmentId)
						// тогда не активна
						return false
					else
						// ни один отдел не выбран - тогда активна
						return true
				}

				// какая то вкладка с отделом
				if (idx === 'ticket/department/' + this.$store.state.ticketData.currentDepartmentId) return true

				return false
			}

			// ответ по умолчанию
			return this.crud === idx
		},
		//---------------------------------------------------------------------
		// определяет - счетчик вкладки тикетов по отделу
		//---------------------------------------------------------------------
		counterTicketTab(idx) {
			// если мы не в тикетнице и не в поддержке
			if (this.crud !== 'ticket' && this.crud !== 'qa') return false

			// если это вкладка "Все"
			if (idx === 'ticket')
				return this.$store.state.ticketData && this.$store.state.ticketData.counters && this.$store.state.ticketData.counters.all ? this.$store.state.ticketData.counters.all : false

			// это какой то отдел - получим его ID из URL
			let _match = idx.match(/ticket\/department\/(\d+)/i)
			if (!_match || !_match[1]) return false
			let _id = parseInt(_match[1])
			if (!_id || isNaN(_id)) return false

			// есть ли для данного отдела счетчик?
			return this.$store.state.ticketData && this.$store.state.ticketData.counters &&
				this.$store.state.ticketData.counters[_id]
				? this.$store.state.ticketData.counters[_id]
				: false
		},
		//---------------------------------------------------------------------
		// выделение активного левого меню,
		// определение CRUD
		// определение верхних вкладок
		//---------------------------------------------------------------------
		markActiveLeftMenu(path) {
			// сразу убераем метки активного пункта левого меню
			if (this.$refs)
			{
				for (let r in this.$refs)
				{
					if (this.$refs[r] && this.$refs[r][0] && this.$refs[r][0].$el)
						this.$refs[r][0].$el.className = ''
				}
			}

			// парсим путь куда переходят
			let _urlParts = path
				.substr(path.charAt(0) === '/' ? 1 : 0)
				.split('/')

			// должны быть минимум две части
			if (_urlParts.length < 2 || !_urlParts[0] || !_urlParts[0].length)
			{
				// бывают пути с одной частью
				if (_urlParts[0] !== 'options' && _urlParts[0] !== '404' && _urlParts[0] !== '500' && _urlParts[0] !== '503' && _urlParts[0] !== 'unsubscribe')
				{
					if (this.$store.state.isDebug) window.DEBUG.error('задан некорректный путь')
					return
				}
			}

			// ищем путь в пунктах левого меню
			let _ref = _urlParts[0]
			// сразу запомним наименование CRUD
			this.crud = _ref

			// если ушли с тикетов (или в просмотр тикета) - обнулим все нотификации
			if (this.crud !== 'ticket' || (_urlParts[1] !== 'list' && _urlParts[1] !== 'department'))
				EventBus.$emit('w5-notificator-remove-all')
			// если мы не в просмотре тикета - нужно убрать специальные нотификации
			if (this.crud !== 'ticket' || _urlParts[1] !== 'view')
			{
				EventBus.$emit('w5-notificator-del-special', 'view')
				EventBus.$emit('w5-notificator-del-special', 'post')
			}

			// бежим по всем пунктам левого меню - в них хранятся вкладки
			for (let m in this.Config.leftMenu)
			{
				// текущий пункт
				let menu = this.Config.leftMenu[m]

				// если есть вкладки у данного пункта меню и там есть искомый путь
				if (menu && menu['tabs'] && menu['tabs'][_ref])
				{
					// запомним вкладки
					this.tabs = Object.assign({}, menu['tabs'])

					// нужно выделить пункт левого меню
					let _find = '_' + m + '_list'

					// Частные случаи:
					if (path === '/bonus/convert') _find = '_bonus_convert'
					if (path === '/dashboard/info') _find = '_dashboard_info'
					if (this.$store.state.user_type !== 'admin' &&
						(path.indexOf('/user/list') === 0 ||
						path.indexOf('/logs/list') === 0 ||
						path.indexOf('/request/list') === 0 ||
						path === '/options' ||
						path.indexOf('/user/alerts') === 0))
						_find = '_dashboard_info'
					if (this.crud === 'ticket') _find = 'ticket'
					if (path === '/qa/list') _find = 'ticket'
					if (path.indexOf('/dns/list') === 0 || path.indexOf('/dns/view') === 0 ||
						path.indexOf('/person/list') === 0)
						_find = '_domains_list'
					if (
						(path.indexOf('/dns/list') === 0 || path.indexOf('/dns/view') === 0) &&
						(this.AppName === 'macloud' || this.AppName === 'vdsina.com')
					)
						_find = '_dns_list'

					// ставим активный пункт в следующем тике
					this.$nextTick(() => {
						for (let r in this.$refs)
						{
							if (this.$refs[r] && this.$refs[r][0] && this.$refs[r][0].$el)
							{
								if (r === _find) this.$refs[r][0].$el.className = 'w5-left-menu-active'
								else this.$refs[r][0].$el.className = ''
							}
						}
					})

					// на этом все
					return
				}

				// если это домены и DNS-записи
				if ((m === 'domains' && _ref === 'dns-records') ||
					(m === 'template' && _ref === 'iphistory') ||
					(m === 'template' && _ref === 'ipptrpool') ||
					(m === 'logs' && _ref === 'ipptrpool') ||
					(m === 'dashboard' && _ref === 'ipptrpool'))
				{
					// ссылка на элемент
					let _find = '_domains_list'
					if (m === 'template') _find = '_template_list'
					if (m === 'dashboard') _find = '_dashboard_info'
					if (m === 'logs')
					{
						if (this.$store.state.menuSelectingPreset === 'admin_view_ipptrpool')
							_find = '_logs_list'
						else
							_find = '_template_list'
					}
					// ставим активный пункт в следующем тике
					this.$nextTick(() => {
						for (let r in this.$refs)
						{
							if (this.$refs[r] && this.$refs[r][0] && this.$refs[r][0].$el)
							{
								if (r === _find) this.$refs[r][0].$el.className = 'w5-left-menu-active'
								else this.$refs[r][0].$el.className = ''
							}
						}
					})

					// тут просто выход из цикла - так как нужно еще проставить таб
					break
				}
			}

			// если такой пункт не найден - нужно завести свою вкладку
			this.tabs = {}
			// частные случаи
			if (/\/user\/alerts\/\d+/i.test(path))
			{
				this.tabs[this.crud] = 'main/email_subs_mini'
			}
			else if (path === '/404' || path === '/500' || path === '/503')
			{
				this.tabs[this.crud] = 'menu/cp'
			}
			// свои вкладки для сотрудниов
			else if ((_ref === 'ipptrpool' || _ref === 'iphistory') &&
				this.$store.state.user_type === 'admin' &&
				this.Config.leftMenu &&
				this.Config.leftMenu['template'] &&
				this.Config.leftMenu['template']['tabs'])
			{
				// если сотрудник смотрит из логов
				if (this.$store.state.menuSelectingPreset === 'admin_view_ipptrpool')
				{
					this.tabs[this.crud] = this.crud + '/title'
				}
				else
				{
					this.tabs = Object.assign({}, this.Config.leftMenu['template']['tabs'])
				}
			}
			else this.tabs[this.crud] = this.crud + '/title'
		},
		//---------------------------------------------------------------------
		// открытие меню выбора вкладки для мобильных
		//---------------------------------------------------------------------
		openMibileTabsMenu() {
			if (!this.tabs || this.tabs.length <= 1) return
			this.mobileTabsMenuShow = true
		},
		//---------------------------------------------------------------------
		// закрытие меню выбора вкладки для мобильных
		//---------------------------------------------------------------------
		hideMibileTabsMenu() {
			this.mobileTabsMenuShow = false
		},
		//---------------------------------------------------------------------
		// добавления сообщения-нотификации по тикетам
		//---------------------------------------------------------------------
		addTicketNotification(parts) {
			// проверка данных
			if (!parts || !Array.isArray(parts) || parts[1] !== 'ticket' || !parts[2]) return

			// получим ID тикета
			let _id = parseInt(parts[2])
			if (!_id || isNaN(_id) || _id <= 0) return

			// получим заголовок тикета
			let _title = parts.slice(3).join(' ')

			// если это изменение тикета
			if (parts[0] === 'update')
			{
				EventBus.$emit('w5-notificator-add', {
					'title': 'ticket/updated',
					'message': _title,
					'class': 'info',
					'type': 'ticket',
					'id': _id
				})
			}
		},
		//---------------------------------------------------------------------
		// обработка Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// разобъем сообщение на части
			let _parts = msg.split(' ')

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это пуш по тикетам
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (_parts && _parts[1] === 'ticket')
			{
				// сразу получим ID тикета
				let _ticketId = _parts[2]

				// если это изменение тикета
				if (_parts[0] === 'update' && _ticketId)
				{
					// сразу запрос счетчика тикетов по пушу
					this.$store.dispatch('getTicketCounters', true)
					// нотификация, только если это сделали не мы
					if (!this.$store.state.ItIsMe) this.addTicketNotification(_parts)
					// обнулим переменную через паузу, что бы другие компоненты тоже могли его просмотреть
					this.$nextTick(() => { this.$store.commit('ItIsMe', false) })
				}
				// если это просмотр или редактирование тикета
				if ((_parts[0] === 'view' || _parts[0] === 'post') && _parts.length === 3 && _ticketId)
				{
					// если мы в просмотре именно того самого тикета
					if (this.$route.path.indexOf('/ticket/view/' + _ticketId) >= 0)
					{
						// ID тикета известно - запросим статус
						this.$store.commit('getTicketState', _ticketId)
					}
				}

				// ветка обработки тикетам по пушам закончена
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если этот пуш по заявкам - запрос счетчика активных заявок
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (_parts && _parts[1] === 'request')
				this.$store.dispatch('getRequestCounter', true)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверка корректности
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (!_parts || _parts.length < 3) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// далее нам нужно обрабатывать пуши только для клиентов
			// так как здесь будет обрабатываться информация только по операциям
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.$store.state.user_type !== 'client') return

			// нужно обрабатывать только обновления балансов
			if (_parts[0] !== 'update' || _parts[1] !== 'operation') return

			// это обновление операции - нужно запросить эту операцию
			this.$http.get(Vue.APIServerUrl + '/operation/view/' + _parts[2]).then(
				// если успешно получили ответ - значит проводка по нашему счету
				response => {
					// если ответ корректный
					if (response.data && response.data.status === 'ok')
					{
						// обновим баланс
						this.$store.commit('getUserData')

						// дадим команду на редирект только если прошла оплата
						if (response.data.operation &&
							response.data.operation.operation_status &&
							'value' in response.data.operation.operation_status &&
							response.data.operation.operation_status.list &&
							typeof response.data.operation.operation_status.list === 'object')
						{
							if (response.data.operation.operation_status.list[response.data.operation.operation_status.value] === 'operation/status_paid')
							{
								EventBus.$emit('w5-redirect', {
									id: _parts[2],
									url: '/operation/list'
								})
							}
						}
					}
				}
			)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// формирует URL для верхних вкладок
		//---------------------------------------------------------------------
		makeTabUrl(idx, tab) {
			// частные случаи
			if (idx === 'alerts' && tab === 'main/email_subs_mini' && this.$store.state.user_type !== 'admin') return '/user/alerts'
			if (idx === 'service' || idx === 'ticketmessage') return this.$route.path
			if (/^ticket\/department\/\d+$/i.test(idx)) return '/' + idx
			if (idx === 'bonus' && this.$store.state.user_type !== 'admin') return '/bonus/convert'
			if (idx === 'unsubscribe' && tab === 'unsubscribe/title') return this.$route.path
			if (idx === 'dashboard' && tab === 'main/my_account_info' && this.$store.state.user_type !== 'admin') return '/dashboard/info'
			if (idx === 'dns-records' && tab === 'dns-records/title')
			{
				if (this.$store.state.domainRecordId) return '/dns/view/' + this.$store.state.domainRecordId
				else return '/dns/list'
			}
			if (idx === 'email' && tab === 'email/title') return this.$route.path
			if (idx === 'ipptrpool' && tab === 'ipptrpool/title') return this.$route.fullPath

			// и для сотрудников тоже
			if (this.$store.state.user_type === 'admin')
			{
				if (idx === 'dashboard' && tab === 'main/my_account_info')
					return this.$route.path
			}

			// общий случай
			return '/' + idx + (idx === 'options' || idx === '404' || idx === '500' || idx === '503' ? '' : '/list')
		},
		//---------------------------------------------------------------------
		// перенаправляет в список операций с определенным фильтром
		//---------------------------------------------------------------------
		GoToOperation(where) {
			// это только для клиентов
			if (this.$store.state.user_type !== 'client') return

			// закроем баланс
			this.showBalanceData = false
			this.clickOnSideMenu()

			// готовим объект фильтра
			let _obj = {
				'crud': 'operationClientPurse',
				'object': where
			}

			// записываем фильтр в состояние Vuex
			this.$store.commit('setCrudFilter', _obj)

			// делаем редирект
			if (this.$route.path !== '/operation/list')
				// если мы в другом CRUD - просто пуш в историю
				this.$router.push('/operation/list')
			else
				// если мы уже в это месте - эмуляция пуша для рефреша
				EventBus.$emit('w5-push', 'reload operation list')
		},
		//---------------------------------------------------------------------
		// обновился список отделов для тикет системы
		//---------------------------------------------------------------------
		ticketDepartmentsHandler() {
			// реагируем только если это сотрудник и он в тикетах
			if (this.$store.state.user_type !== 'admin' || this.crud !== 'ticket') return
			// обновляем верхние вкладки с учетом данных об отделах
			this.tabs = Object.assign({}, this.$store.state.adminConfig.leftMenu.ticket.tabs)
		},
		//---------------------------------------------------------------------
		// создание VDS клиентом из левого меню
		//---------------------------------------------------------------------
		createVdsByClient(e) {
			this.clickOnSideMenu(e)
			this.$router.push('/vds/create')
		},
		//---------------------------------------------------------------------
		// обработчик: клавиша на документе
		//---------------------------------------------------------------------
		documentKeyDown(e) {
			if (!e || !e.keyCode) return
			if (e.keyCode === 27) {
				if (this.showBalanceData) this.showBalanceData = false
				if (this.showConfirmModalDialog) this.hideConfirmModalDialog()
			}
		},
		//---------------------------------------------------------------------
		// обработчик: скролл на документе
		//---------------------------------------------------------------------
		documentScroll() {
			this.showBalanceData = false
		},
		//---------------------------------------------------------------------
		// обработчик: клик на документе
		//---------------------------------------------------------------------
		documentClick() {
			this.showBalanceData = false
		},

		//---------------------------------------------------------------------
		// скрытие диалога подтверждеия
		//---------------------------------------------------------------------
		hideConfirmModalDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showConfirmModalDialog = false
			this.hideModalMask()
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// обработчик: компонент создан
	//=========================================================================
	created() {
	},
	//=========================================================================
	// обработчик: компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		this.$nextTick(function() {
			// выделяем пункт левого меню при создании компонента
			this.markActiveLeftMenu(this.$route.path)
			// навешиваем обработчик на ресайз окна
			window.addEventListener('resize', this.getWindowWidth)
			// вызываем функцию определения ширины документа
			this.getWindowWidth()
		})

		document.addEventListener('keydown', this.documentKeyDown)
		document.addEventListener('scroll', this.documentScroll)
		document.addEventListener('click', this.documentClick)

		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
		// подписка на обновление списка отделов для тикет-системы
		EventBus.$on('w5-ticket-departments', this.ticketDepartmentsHandler)
		// выход из системы
		EventBus.$on('w5-logout', this.exitFromApp)
	},
	//=========================================================================
	// обработчик: перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.documentKeyDown)
		document.removeEventListener('scroll', this.documentScroll)
		document.removeEventListener('click', this.documentClick)
		window.removeEventListener('resize', this.getWindowWidth)
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
		EventBus.$off('w5-ticket-departments', this.ticketDepartmentsHandler)
		EventBus.$off('w5-logout', this.exitFromApp)
	},
	//=========================================================================
	// наблюдения
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			// обнуляем название CRUD
			this.crud = null
			// выделяем пункт левого меню при смене текущего URL
			this.markActiveLeftMenu(to.path)
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		notice,
		Money,
		Lang
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
/*
 * For fixed navbar
 */
body {
	padding-top: 50px;
}

/*
 * menu in navbar
 */
.w5-navbar-link {
	font-size: 16px;
	margin-left: 15px !important;
	padding: 15px 0 !important;
	cursor: pointer;
	user-select: none;
}

/*
 * link of logo in navbar
 */
.w5-navbar-logo-link {
	margin-left: -5px !important;
	color: #2880ba !important;
	font-weight: bold;
	font-size: 24px;
	
}

.w5-navbar-logo-img {
	float: left;
	height: 30px;
	margin-top: -5px;
	margin-right: 10px;
}

.w5-account-info {
	display: inline-block;
	float: left;
}

@media (max-width: 767px) {
	.w5-navbar-logo-link {
		margin-left: 10px !important;
	}

	.w5-navbar-link .svg-inline--fa {
		font-size: 21px;
	}

	.last-right {
		padding-right: 15px !important;
	}
}

/*
 * Side bar
 */
.sidebar {
    z-index: 998;
    display: block;
    padding: 15px 20px 20px;
	text-align: left;
}

.sidebar .nav > li > a {
	padding: 10px;
	color: #787878;
	border: 1px solid transparent;
}

.sidebar .nav > li > a:focus, .sidebar .nav > li > a:hover {
    background-color: transparent;
}

.sidebar .nav > li > a.router-link-active, .sidebar .nav > li > a.w5-left-menu-active {
	border: 1px solid #eee;
	border-radius: 4px;
}

@media (max-width: 767px) {
	.sidebar {
		position: fixed;
		top: 51px;
		bottom: 0;
		left: 0;
		width: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		background-color: white;
		border-right: 1px solid #eee;
	}	
}

@media (min-width: 1921px) {
	.sidebar {
		font-size: 18px;
		max-width: 290px;
	}

	.sidebar .nav > li > a {
		padding: 20px;
	}
}

/*
 * Main block
 */
.main-for-client {
	padding: 15px;
	max-width: 1000px;
}

.main-for-admin {
	padding: 15px;
	max-width: 1200px;
}

@media (min-width: 1921px) {
	.main-wrapper {
		max-width: 1700px;
		margin: 0 auto;
	}

	.main-for-client {
		/*margin-left: calc(50% - 600px);*/
		max-width: 1400px;
	}

	.main-for-admin {
		/*margin-left: calc(50% - 600px);*/
		max-width: 1400px;
	}

	.nav-tabs>li>a {
		font-size: 18px;
		padding: 10px 20px;
	}

	.filter-links-block {
		font-size: 18px;
	}

	.btn {
		font-size: 16px;
	}

	.btn-submut-extra-small {
		font-size: 12px;
	}

	.w5-column-opers {
		width: 60px;
	}

	.w5-form-wrapper {
		max-width: 1200px;
	}
}

/*
 * user avatar on top menu
 */
.user-mini-avatar {
	float: left;
    width: 32px;
    height: 32px;
    border: 1px solid #ccc;    
    border-radius: 16px;
    margin-top: -5px;
    margin-right: 4px;
}

img.pull-left {
	margin-right: 6px;
}

/*
 * блок баланса клиента
 */
.w5-client-balance {	
	padding: 20px 10px 15px 10px;
	margin-top: 20px;	
    border: 1px solid #eee;
    border-radius: 4px;
}

span.span-link {
	color: #2880da;
	cursor: pointer;
}
.w5-application.mc span.span-link {
	color: #3250ba;
}

span.ticket-message-counter-badge {
	font-size: 10px !important;
	font-weight: normal !important;
	background-color: #2c8ad8;
	margin-left: 6px;
}
.w5-application.mc span.ticket-message-counter-badge {
	background-color: #01196f;
}

.taped {
	background-color: #ddd !important;
}

.navbar-default .navbar-toggle:focus, .navbar-default .navbar-toggle:hover {
    background-color: transparent;
    border-color: #ddd;
}

.navbar-default .navbar-toggle {
	margin-left: 10px;
	background-color: transparent;
    border-color: #ddd;
}


.info-box-balance {
	margin-bottom: 5px;
    display: block;
    height: 44px;
    background: #fff;
}

.info-box-balance-icon {
    display: block;
    float: left;
    height: 100% !important;
    width: 40px;
    text-align: center;
}
.info-box-balance-icon.bg-aqua {
	cursor: pointer;
}

.info-box-balance-icon > span {
	font-size: 24px;
	font-weight: 400;
	line-height: 44px;
}
.info-box-balance-icon > svg.svg-inline--fa {
	font-size: 24px;
	margin-top: 10px;
}

.info-box-balance-content {
    padding: 5px 0 5px 10px;
    margin-left: 40px;
}

.info-box-balance-text {
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 0.8;
    color: black;
}

.info-box-balance-value {
	display: inline-block;
	margin-top: 6px;
    font-weight: 500;
    font-size: 13px;
}

.for-balance-currency {
	font-weight: 500;
    font-size: 13px;	
}

.info-box-balance-value.for-balance {
	cursor: pointer;
	color: #2880da;
}
.w5-application.mc .info-box-balance-value.for-balance {
	color: #3250ba;
}

.info-box-balance-content.bonus-balance > .info-box-balance-value {
	font-size: 13px;	
}

.info-box-balance-content.real-balance > .info-box-balance-text,
.info-box-balance-content.real-balance > .info-box-balance-value,
.info-box-balance-content.real-balance > .for-balance-currency {
	font-size: 15px;
}

@media (max-width: 1200px) {
	.info-box-balance-content > .w5-question-block.small > .w5-question {		
		font-size: 8px;
		width: 10px;
		height: 10px;
		line-height: 10px;
		border-radius: 5px;
	}
}

@media (min-width: 1025px) and (max-width: 1200px) {
	.info-box-balance-icon {
		width: 16px;
		background-color: white !important;
	}
	.info-box-balance-icon > svg.svg-inline--fa {
		font-size: 14px;
	}
	.info-box-balance-icon > svg.svg-inline--fa {
		color: #00c0ef !important;
	}
	.w5-application.mc .info-box-balance-icon > svg.svg-inline--fa {
		color: #fff !important;
	}
	.info-box-balance-icon > svg.fa-exclamation-circle {
		color: #a0c0c0 !important;
	}
	.info-box-balance-content {
		margin-left: 20px;
		padding-left: 5px;
	}

	.info-box-balance-content.real-balance > .info-box-balance-text,
	.info-box-balance-content.real-balance > .info-box-balance-value,
	.info-box-balance-content.real-balance > .for-balance-currency {
		font-size: 14px !important;
	}
}

@media (min-width: 768px) and (max-width: 1024px) {
	.info-box-balance-icon {
		display: none;		
	}
	.info-box-balance-content {
		margin-left: 0;
		padding-left: 0;
	}
	.info-box-balance-text {
	    font-size: 11px;
	}
	.info-box-balance-value {
		font-size: 12px !important;
	}

	.w5-client-balance {
		padding: 10px 5px 5px 5px;
	}
	
	.info-box-balance-content.real-balance > .info-box-balance-text,
	.info-box-balance-content.real-balance > .info-box-balance-value,
	.info-box-balance-content.real-balance > .for-balance-currency {
		font-size: 12px !important;
	}
}

@media (max-width: 767px) {
	.balance-rest.visible-xs {
		display: inline-block !important
	}
}

</style>



// WEBPACK FOOTER //
// workBoard.vue?9007504e